/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  DeleteApiV1ExamIdMutationResponse,
  DeleteApiV1ExamIdPathParams,
  DeleteApiV1ExamId400,
  DeleteApiV1ExamId401,
  DeleteApiV1ExamId404,
  DeleteApiV1ExamId500,
} from "../../types/examEvaluationController/DeleteApiV1ExamId.ts";

function getDeleteApiV1ExamIdUrl(id: DeleteApiV1ExamIdPathParams["id"]) {
  const res = { method: "DELETE", url: `/api/v1/exam/${id}` as const };
  return res;
}

/**
 * @description Remove uma prova. Quando a prova possui publicações vinculadas, realiza exclusão lógica (desativa o registro). Caso contrário, realiza exclusão física em cascata, removendo questões, idiomas e a prova. **(Requer Authorization para autenticação)**
 * @summary Excluir prova (Requer Authorization para autenticação)
 * {@link /api/v1/exam/:id}
 */
export async function deleteApiV1ExamId(
  id: DeleteApiV1ExamIdPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiV1ExamIdMutationResponse,
    ResponseErrorConfig<
      | DeleteApiV1ExamId400
      | DeleteApiV1ExamId401
      | DeleteApiV1ExamId404
      | DeleteApiV1ExamId500
    >,
    unknown
  >({
    method: "DELETE",
    url: getDeleteApiV1ExamIdUrl(id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
